import React, { useState, useEffect } from 'react';
import { useParams } from '@thd-olt-component-react/router';
import _isEmpty from 'lodash/isEmpty';
import _has from 'lodash/has';
import {
  shape, arrayOf, string, func, number
} from 'prop-types';
import {
  Button,
  Chip,
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  Tile,
  TileGroup,
  TileStateIndicator
} from '@one-thd/sui-atomic-components';
import { Row } from '@thd-olt-component-react/core-ui';
import { ArrowDown, Close } from '@one-thd/sui-icons';
import {
  getFiltersFromLocalStorage,
} from '../../../../../pages/collection/common';

export const AdvancedFilters = ({
  filterOptions,
  advancedFilters,
  updateAdvancedFilters,
  selectedCategory,
  resultCount
}) => {

  const buttonClasses = 'sui-btn sui-btn-text sui-btn-text-focus sui-btn-text-active '
    + 'sui-btn-text-hover sui-font-regular sui-text-base sui-leading-normal sui-tracking-normal '
    + 'sui-normal-case sui-line-clamp-unset sui-font-normal sui-border-0 sui-whitespace-nowrap';

  const omsId = '334219672';

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [filterType, setFilterType] = useState('');
  const [selectedFilters, setSelectedFilters] = useState(getFiltersFromLocalStorage(omsId));
  const [optionsList, setOptionsList] = useState('');

  const getOptionValue = (optionValue) => {
    if (['width', 'height'].includes(filterType?.toLowerCase().trim())) {
      return `${optionValue}"`;
    }
    return optionValue;
  };

  useEffect(() => {
    if (!_isEmpty(filterType)) {
      const options = filterOptions.filters.map((option) => {
        if (option.label === filterType) {
          return option.refinements.map((refinement) => refinement.label);
        }
        return null;
      }).filter((element) => element);

      const optionList = options.flat().sort();
      setOptionsList(optionList);
    } else {
      setOptionsList('');
    }
  }, [filterType]);

  const toggleDrawer = (filterTypeValue) => (event) => {
    event.preventDefault();
    event.stopPropagation();
    setDrawerOpen(!drawerOpen);
    setFilterType(filterTypeValue);
  };

  const handleSelectedFilter = (_event, option) => {
    setSelectedFilters(option);
  };

  const applyFilters = (event) => {
    setDrawerOpen(!drawerOpen);
    setFilterType(undefined);

    updateAdvancedFilters(event, selectedFilters);
  };

  const removeFilter = (event, filter) => {
    event.preventDefault();
    event.stopPropagation();
    const selectedFiltersCopy = selectedFilters || advancedFilters;
    const updatedFilters = selectedFiltersCopy.filter((filterValue) => filterValue !== filter);
    setSelectedFilters(updatedFilters);

    updateAdvancedFilters(event, updatedFilters);
  };

  const removeAllFilter = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setSelectedFilters('');

    updateAdvancedFilters(event, []);
  };

  useEffect(() => {
    if (!_isEmpty(selectedCategory)) {
      const localStorageFilters = []; // getFiltersFromLocalStorage(omsId) || [];
      if (localStorageFilters.length > 0) {
        setSelectedFilters(localStorageFilters);
      } else {
        setSelectedFilters('');
      }
    }
  }, [selectedCategory]);

  return (
    <>

      <Row
        className="sui-relative sui-outline-0 sui-flex
        sui-gap-6 sui-pb-2 sui-overflow-x-auto sui-flex-row sui-whitespace-nowrap"
        style={{ justifyContent: 'flex-start' }}
      >
        {filterOptions?.filterNames?.map((filterTypeValue) => (
          <Button
            key={filterTypeValue.label}
            className={buttonClasses}
            endIcon={ArrowDown}
            variant="text"
            onClick={toggleDrawer(filterTypeValue.label)}
          >
            {filterTypeValue.displayLabel}
          </Button>
        ))}
        <Drawer
          open={drawerOpen}
          position="right"
          onClose={toggleDrawer()}
          DrawerRootProps={{ style: { transition: 'right 0.3s ease-in 0s' } }}
        >
          <div className="cabinet-collection-drawer-component">
            <DrawerHeader
              title={filterType}
              onBack={toggleDrawer()}
              onClose={undefined}
            />
            <DrawerBody>
              <TileGroup
                value={selectedFilters}
                onChange={handleSelectedFilter}
                disableExclusive
              >
                {!_isEmpty(optionsList) && optionsList.map((option) => (
                  <Tile
                    key={`key-${getOptionValue(option)}`}
                    value={`${filterType} - ${getOptionValue(option)}`}
                    aria-label={option}
                    grow
                    style={{ width: '100%' }}
                  >
                    <div
                      className="sui-flex sui-h-full sui-items-start sui-gap-2 sui-grow"
                      style={{ marginLeft: '1rem' }}
                    >
                      <p
                        className="sui-font-regular sui-text-base sui-leading-tight sui-tracking-normal
                      sui-normal-case sui-line-clamp-unset sui-font-normal sui-text-primary"
                      >
                        <div className="sui-py-1">
                          <p
                            className="sui-font-regular sui-text-base
                          sui-tracking-normal sui-normal-case sui-line-clamp-unset
                          sui-font-normal sui-text-primary sui-text-left"
                          >
                            {getOptionValue(option)}
                          </p>
                        </div>
                      </p>
                    </div>
                    <TileStateIndicator />
                  </Tile>
                ))}
              </TileGroup>
            </DrawerBody>
            <DrawerFooter>
              <div className="sui-flex sui-gap-2 sui-pb-2">
                <Button fullWidth onClick={(event) => applyFilters(event)}>Apply</Button>
              </div>
              <div className="sui-flex sui-gap-2">
                <Button fullWidth onClick={toggleDrawer()} variant="secondary">Cancel</Button>
              </div>
            </DrawerFooter>
          </div>
        </Drawer>
      </Row>
      {
        advancedFilters?.length > 0 && (
          <Row
            className="sui-relative sui-outline-0 sui-flex sui-gap-4 sui-pb-4 sui-pt-2 sui-flex-wrap"
          >
            {advancedFilters.map((filter) => (
              <Chip
                key={filter}
                title={filter.split(' - ')[0]}
                label={filter.split(' - ')[1]}
                onClick={(event) => removeFilter(event, filter)}
                endIcon={<Close size="small" />}
              />
            ))}
          </Row>
        )
      }

    </>
  );
};

AdvancedFilters.propTypes = {
  filterOptions: shape({}),
  advancedFilters: arrayOf(string).isRequired,
  updateAdvancedFilters: func.isRequired,
  selectedCategory: string.isRequired,
  resultCount: number,
};

AdvancedFilters.defaultProps = {
  filterOptions: {},
  resultCount: 0,
};
